import Cookies from "js-cookie";
import { User } from "../types";
import { BUCKET_PACOCA_URL, BUCKET_REFLEXO_URL } from "./vars";
import { t } from "../i18nTranslate";
import disposable from '../../../assets/disposable.json';

export const isAuthenticated = () => {
    return Cookies.get("token") !== null;
};

export const isMyLove = (user: User | null) => {
    return user?.id === 5;
}

export const authId = () => {
    const userJson = Cookies.get("user");

    if (userJson) {
        // Analisa a string JSON para um objeto
        const user = JSON.parse(userJson);
        
        // Agora você pode acessar o ID do usuário
        return user.id; // Acesse o ID do usuário
    } else {
        return null;
    }
};

export const validatePrev = (user?: User | null) => {
    if(user && !user?.email_verified_at && isAuthenticated())
        return t("user.validate.email.emailVerified");
    return null
}

export const authUser = () => {
    const userJson = Cookies.get("user");

    if (userJson) {
        // Analisa a string JSON para um objeto
        const user = JSON.parse(userJson);
        
        // Agora você pode acessar o ID do usuário
        return user; // Acesse o ID do usuário
    } else {
        return null;
    }
};

export const needToActive2fa = (user: User| null) => {
    if(!user) return false;
    if ((user?.position > 0 || user?.stamps?.includes("brown")) && !user.google2fa_enabled) {
        return true;
    }
}

export const hasPosition = (user: User| null) => {
    if(!user) return false
    if(!user?.stamps?.length && (!user?.position || user?.position <= 0)) return false

    return user?.position > 0 || user.stamps?.includes("brown")
} 

export const isVerifyed = (user: User| null) => {
    if(!user) return false
    if(!user?.stamps?.length && (!user?.position || user?.position <= 0)) return false

    return user?.position > 0 || user.stamps?.includes("black") || user.stamps?.includes("blue")
}

export enum Bucket {
    PACOCA = "pacocaa",
    REFLEXO = "reflexo"
}

export const getImageUser = (path?: string, bucket: Bucket = Bucket.PACOCA, name?: string) =>{
    return path ? `${getBucketUrl(bucket)}/${path}` : getImageUserNotFound(name);
}

export const getImageUserNotFound = (name?: string) =>{
    return name?.length ? `https://ui-avatars.com/api/?name=${name?.replaceAll(" ", "+")}&background=random&size=64` : "/img/img-account.png";
}

export const getBucketUrl = (bucket: Bucket) => {
    switch(bucket){
        case Bucket.PACOCA:
            return BUCKET_PACOCA_URL;
        case Bucket.REFLEXO:
            return BUCKET_REFLEXO_URL;
    }
};

export function validateUsername(raw: string): string | null {
    const cleaned = sanitizeUsername(raw);

    if (!cleaned) {
        return t("user.validate.username.required");
    }

    if (cleaned.length > 20) {
        return t("user.validate.username.maxLength");
    }

    if (/^[.]/u.test(cleaned)) {
        return t("user.validate.username.startWithDot");
    }

    // precisa ter ao menos letra ou número (qualquer script Unicode)
    if (!/[\p{L}\p{N}]/u.test(cleaned)) {
        return t("user.validate.username.mustContainLetterOrNumber");
    }

    if (cleaned.includes("@")) {
        return t("user.validate.username.containsAtSymbol");
    }

    // bloqueia cirílico — principal vetor de spoofing visual (U+0400–U+052F)
    if (/[\u0400-\u052F]/u.test(cleaned)) {
        return t("user.validate.username.containsCyrillic");
    }

    // regex que aceita letra/número Unicode, underscore ou emoji no final
    const usernameRegex = /^(?!.*\/)(?:@)?(?!\.)(?=[^\s]*[\p{L}\p{N}])[^\s@]*(?:[\p{L}\p{N}_]|[\p{So}\p{Emoji_Presentation}])$/u;

    if (!usernameRegex.test(cleaned)) {
        return t("user.validate.username.invalidCharacters");
    }

    return null;
}

export function isEveryOnline(id?: number){
    if(!id) return false;
    if(id == 23860) return true;
    if(id == 39860) return true;
}

export function validateEmail(email?: string){
    if(!email) return;

    if(!email.includes("@"))
        return t("user.validate.email.invalid");

    if(isDisposable(email))
        return t("user.validate.email.disposable");

    return null
}

export function isDisposable(email?: string) {
    if(!email) return true;
    if(!email.includes("@")) return false;

    const extra = ["ryzid.com", "poisonword.com"];
    const domain = email?.split('@')[1].toLowerCase();

    return disposable.includes(domain) || extra.includes(domain);
}

export function sanitizeUsername(value: string): string {
    if (typeof value !== "string") return value as any;

    return value
        // espaços invisíveis + caracteres de controle (JS compatível)
        .replace(
            /[\u{00A0}\u{2000}-\u{200B}\u{202F}\u{205F}\u{3000}\u{3164}\p{C}]+/gu,
            ""
        )
        // username não aceita espaços
        .replace(/\s+/gu, "")
        .trim();
}
